module.exports = __webpack_public_path__ + "img/goodsB6.8e19d1b2.png";